import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  sc: {
    colors: {
      primary: '#309dd1',
      secondary: '#607389',

      // basics
      white: '#ffffff',
      black: '#000000',

      // custom
      greyishBlue: '#607389',

      // design
      whiteOne: '#fafafa',
      green: '#00A651',
      lightGreen: '#73d68d',
      blue: '#4A90E2',
      lightBlue: '#70b3cc',
      orange: '#fcb900',
      lightOrange: '#efcd70',
      red: '#D0021B',
      lightRed: '#F18D8D',
      yellow: '#F5A623',
      gray: '#bdbdbd',
      lightGray: '#dfdfdf',
      grayOne: '#f9f9f9',
      grayTwo: '#232323',
      darkerGray: '#515c6a',
      darkerBlue: '#618bbd',
      shipCove: '#7D9ABD',
      lighterGray: '#f9f9f9',
      mineShaft: '#212121',
      curiousBlue: '#309dd1',
      lynch: '#607389',
    },
  },
  typography: {
    fontSize: 14,
  },
  primaryLighterColor: '#309DD1',
  button: {
    textColor: '#eeeeee',
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      // #4890E5
      main: '#309DD1',
      dark: '#309DD1',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      main: '#84B2E0',
    },
    error: {
      main: '#FC615D',
    },
    text: {
      primary: '#607389',
      secondary: 'rgba(96, 115, 137, 0.8)',
    },
  },
  // we can also override any comp
  overrides: {
    MuiButton: {
      // Name of the component ⚛️ / style sheet
      root: {
        // Name of the rule
        color: '#309DD1', // Some CSS
      },
    },
  },
});

export default theme;
